export default __webpack_public_path__ + "static/personal-loan-99aea30579a9903e694bad58ce173926.png";